module.exports = __webpack_public_path__ + "img/resume.38a0ad3d.png";